module.exports = __webpack_public_path__ + "static/media/tri-bg.b8a65911.svg";